@if (list && !defaults.isReadonlyUser) {
  <table-fixed-header-search-collapse
    id-table="maintenance-control-plan-group-id"
    [header]="header"
    [data]="list"
    [getValue]="getData"
    [selectable]="false"
    [rowNewTemplate]="newgroup"
    [rowEditTemplate]="groupedit"
    [newService]="newService"
    (onDelete)="onDelete($event)"
    (onRowClick)="onRowClick($event)">
  </table-fixed-header-search-collapse>
}

@if (list && defaults.isReadonlyUser) {
  <table-fixed-header-search-collapse
    id-table="maintenance-control-plan-group-id"
    [header]="header"
    [data]="list"
    [getValue]="getData"
    [selectable]="false"
    (onRowClick)="onRowClick($event)">
  </table-fixed-header-search-collapse>
}

<ng-template #groupedit let-index="index">
  <maintenance-control-plan-group-new [header]="header" [list]="list" [rowIndex]="index" [newRow]="false"></maintenance-control-plan-group-new>
</ng-template>

<ng-template #newgroup>
  <maintenance-control-plan-group-new [header]="header" [list]="list" [mcp]="mcp"></maintenance-control-plan-group-new>
</ng-template>
